import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IbNewModalAncillariesService } from './app/features/components/ib-modal/services/ib-new-modal-ancillaries-service';
import { IbBookingSwitchSellModule } from './app/features/components/ib-booking-switch-sell/ib-booking-switch-sell.module';
import { IbDisruptedSeatsModule } from './app/features/components/ib-disrupted-seats/ib-disrupted-seats.module';
import { IbInsuranceAllianzDatalayerUtilsService } from './app/shared/ib-insurance-allianz-datalayer-utils.service';
import { AJSCommonsUtilServiceProvider } from './app/shared/upgraded/ib-commons-utils-bridge.service';
import { AJSDatalayerHelperProvider } from './app/shared/upgraded/ib-datalayer-helper-bridge.service';
import { AJSDigitalDataServiceProvider } from './app/shared/upgraded/ib-digital-data-bridge.service';
import { IbGlobickService } from './app/features/services/services/services/ib-globick/ib-globick.service';
import { AJSCommonsGenericProxyProvider } from './app/shared/upgraded/commons-proxy-bridge.service';

@NgModule({
    declarations: [],
    exports: [CommonModule],
    imports: [
        CommonModule,
        TranslateModule,
        IbDisruptedSeatsModule,
        IbBookingSwitchSellModule
    ],
    providers: [
        IbInsuranceAllianzDatalayerUtilsService,
        AJSDatalayerHelperProvider,
        AJSCommonsUtilServiceProvider,
        AJSDigitalDataServiceProvider,
        IbNewModalAncillariesService,
        IbGlobickService,
        AJSCommonsGenericProxyProvider
    ]
})
export class IbAncillariesAppModule {
}

